/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_C1Inputs */

const en_guide_json_schema_c1 = /** @type {(inputs: Guide_Json_Schema_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`types, required, and the constraint keywords`)
};

const ko_guide_json_schema_c1 = /** @type {(inputs: Guide_Json_Schema_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`types와 required, 그리고 제약 키워드`)
};

const ja_guide_json_schema_c1 = /** @type {(inputs: Guide_Json_Schema_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`types、required、制約キーワード`)
};

/**
* | output |
* | --- |
* | "types, required, and the constraint keywords" |
*
* @param {Guide_Json_Schema_C1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_c1 = /** @type {((inputs?: Guide_Json_Schema_C1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_C1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_c1(inputs)
	if (locale === "ko") return ko_guide_json_schema_c1(inputs)
	return ja_guide_json_schema_c1(inputs)
});